// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "285c3123c41f4adbff1d8f5eba4a0d49",
  base: "https://api.openweathermap.org/data/2.5/",
};
